import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const CustomAlert = ({ text, open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          Alerta!
        </Typography>
        <Typography sx={{ mt: 2 }}>{text}</Typography>
        <Button onClick={onClose} variant="outlined" sx={{ mt: 2 }}>
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default CustomAlert;
